export default __webpack_public_path__ + "static/media/R3.f28f8aa1.JPG";